

export default {
    name: 'HeaderDashboard',
    props: {
        showSubheader: Boolean,
    },
    data() {
        return {
            campaignMoreMenuOpen: false,
            openUserMenu: false,
            isDeleting: false,
        };
    },
    computed: {
        isInsightsOpen() {
            return !!this.$route.path.match(/^\/dashboard\/campaign\/[a-f0-9\-]{36}$/);
        },
        campaignHasResponses() {
            return this.campaign && this.campaign.numberOfVoices > 0;
        },
        isInWidgetConfigMode() {
            return this.$store.getters['ui/isInWidgetConfigMode'];
        },
        campaign() {
            return this.$store.getters['campaign/get'](this.$route.params.id);
        },
        profile() {
            return this.$auth.user;
        },
        showSwitcher() {
            return this.$auth.user.managedProfiles.length > 1;
        },
        plan() {
            return this.$auth.user.environment.planName;
        },
        editLink() {
            if (this.campaign.isNPSCampaign) {
                return `/dashboard/campaign/${this.campaign.id}/edit/nps`;
            } else if (this.campaign.isCSATCampaign) {
                return `/dashboard/campaign/${this.campaign.id}/edit/csat`;
            } else {
                return `/dashboard/campaign/${this.campaign.id}/edit/prompt`;
            }
        },
    },
    methods: {
        toggleWidgetConfigMode() {
            this.$store.commit('ui/toggleWidgetConfigMode');
        },

        showDeleteConfirm() {
            if (confirm('Are you sure you want to delete this campaign?\nYou will also lose access to all contained voices.')) {
                this.changeStatus('deleted');
            }
        },

        async changeStatus(status) {
            this.isDeleting = status === 'deleted';

            try {
                await this.$store
                    .dispatch('campaign/updateCampaign', {
                        campaignID: this.$route.params.id,
                        payload: {
                            status: status,
                        },
                        refreshCampaign: !this.isDeleting,
                    })
                    .finally(() => (this.isDeleting = false));

                if (status === 'deleted') {
                    await this.$router.push('/dashboard');
                }
            } catch (e) {
                // currently the best thing we have at our disposal to check for a specific error
                // 429 would be the HTTP status code (Too Many Requests) here if it wasn't for GraphQL
                if (e.message.match(/\[429\]/)) {
                    this.showUpsellModal({ featureName: 'More Active Campaigns', tier: 'next highest' });
                } else {
                    console.error(e);
                }
            }
        },

        showUpsellModal({ featureName, tier }) {
            this.$store.commit('ui/hideModal');
            this.$store.commit('ui/showModal', {
                component: 'GenericUpsell',
                props: { featureName, tier },
            });
        },

        handleFocusOut() {
            setTimeout(() => (this.campaignMoreMenuOpen = false), 200);
        },

        handleProfileFocusOut() {
            setTimeout(() => (this.openUserMenu = false), 200);
        },

        async logout() {
            await this.$store.dispatch('authStore/logout');
        },

        closeMenu() {
            this.openUserMenu = false;
            this.campaignMoreMenuOpen = false;
        },

        async duplicateCampaign() {
            try {
                const newCampaign = await this.$store.dispatch('campaign/duplicateCampaign', {
                    campaignID: this.campaign.id,
                });

                console.log(newCampaign);

                await this.$router.push(`/dashboard/campaign/${newCampaign.id}`);
            } catch (e) {
                // currently the best thing we have at our disposal to check for a specific error
                // 429 would be the HTTP status code (Too Many Requests) here if it wasn't for GraphQL
                if (e.message.match(/\[429\]/)) {
                    this.showUpsellModal({ featureName: 'More Active Campaigns', tier: 'next highest' });
                } else {
                    console.error(e);
                }
            }
        },
    },
};
